import React, { useState } from "react"

import { gql, useQuery } from "urql"

import { WithLoadingIndicator } from "~tailwindui/Basics"

import ExpenseTable from "./ExpenseTable"

const DeniedExpenses = () => {
  const [page, setPage] = useState(1)
  const [result] = useQuery({
    query: expensesQuery,
    variables: { page },
  })

  if (result.data && result.data.expenses.data.length === 0) return null

  return (
    <WithLoadingIndicator result={result}>
      {({ data: { expenses } }) => (
        <ExpenseTable
          title="Denied Expenses"
          expenses={expenses}
          changePage={setPage}
        />
      )}
    </WithLoadingIndicator>
  )
}

const expensesQuery = gql`
  query DeniedExpenses($page: Int!) {
    expenses(page: $page, state: denied) {
      currentPage
      totalPages
      data {
        id
        expenseType
        description
        comments
        feedback
        formattedAmount
      }
    }
  }
`

export default DeniedExpenses
